export enum RoleTypes {
  ROLE_HELPII = 'ROLE_HELPII',
  ROLE_HELPII_MANAGER = 'ROLE_HELPII_MANAGER',
  ROLE_BANKING_FLOW_CONFIGURATOR = 'ROLE_BANKING_FLOW_CONFIGURATOR',
  ROLE_BANKING_PARTNER_CONFIGURATOR = 'ROLE_BANKING_PARTNER_CONFIGURATOR',
  ROLE_EMPLOYEE_IT = 'ROLE_EMPLOYEE_IT',
}
